import { Calendar, Compass, LayoutDashboard, ListChecks, Settings, Utensils } from "lucide-react";

// Drawer / rail destinations in canonical order (mockup app.jsx).
// `i18nKey` resolves against the `nav` namespace in messages/*.json.
export const NAV_DESTINATIONS = [
  { id: "discover", href: "/discover", i18nKey: "discover", icon: Compass },
  { id: "dashboard", href: "/dashboard", i18nKey: "dashboard", icon: LayoutDashboard },
  { id: "lists", href: "/lists", i18nKey: "lists", icon: ListChecks },
  { id: "recipes", href: "/recipes", i18nKey: "recipes", icon: Utensils },
  { id: "calendar", href: "/calendar", i18nKey: "calendar", icon: Calendar },
  { id: "settings", href: "/settings", i18nKey: "settings", icon: Settings },
] as const;

export type NavDestinationId = (typeof NAV_DESTINATIONS)[number]["id"];
